/* RAVIN / Locale-safe editorial and storefront navigation.
 * Only adjusts Arabic storefront links that omit Shopify's locale root.
 * Leaves external destinations, checkout, accounts and native locale switching alone.
 */
(() => {
  if (window.RavinLocaleLinks) return;
  const rootPath = (document.documentElement.dataset.ravinRootPath || window.Shopify?.routes?.root || '/').replace(/\/+$/, '');
  const isArabic = (document.documentElement.lang || '').toLowerCase().startsWith('ar');
  const localePrefix = rootPath && rootPath !== '/' ? rootPath : '';
  const storefrontPath = /^\/(?:collections|products|pages|search|blogs|policies|cart)(?:\/|$)/i;
  const explicitLocale = /^\/(?:en|ar)(?:-[a-z]{2})?(?:\/|$)/i;

  function href(raw) {
    if (!isArabic || !localePrefix || typeof raw !== 'string') return raw;
    const value = raw.trim();
    if (!value || value[0] === '#' || value[0] === '?'
        || /^(?:javascript|mailto|tel|sms|data):/i.test(value)
        || value.startsWith('//')) return raw;
    let url;
    try { url = new URL(value, window.location.href); }
    catch (_) { return raw; }
    if (!/^https?:$/.test(url.protocol) || url.origin !== window.location.origin) return raw;
    const path = url.pathname;
    if (path === localePrefix || path.startsWith(localePrefix + '/') || explicitLocale.test(path)) return raw;
    if (path !== '/' && !storefrontPath.test(path)) return raw;
    return localePrefix + path + url.search + url.hash;
  }

  function fixLink(anchor) {
    if (!anchor || anchor.hasAttribute('download') || anchor.hasAttribute('hreflang')
        || anchor.closest('[data-ravin-skip-locale], form[action*="/localization"]')) return;
    const original = anchor.getAttribute('href');
    if (!original) return;
    const adjusted = href(original);
    if (adjusted !== original) anchor.setAttribute('href', adjusted);
  }

  window.RavinLocaleLinks = { href };
  if (!isArabic || !localePrefix) return;

  function fixFromEvent(event) {
    const anchor = event.target?.closest?.('a[href]');
    if (anchor) fixLink(anchor);
  }

  ['pointerdown', 'click', 'auxclick', 'contextmenu', 'focusin'].forEach(type => {
    document.addEventListener(type, fixFromEvent, true);
  });
  const scan = () => document.querySelectorAll('a[href]').forEach(fixLink);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan, { once: true });
  } else {
    scan();
  }
  document.addEventListener('shopify:section:load', event => {
    event.target?.querySelectorAll?.('a[href]').forEach(fixLink);
  });
})();